import React from 'react'
import InfoPage from "./InfoPage"
import meFull from "../../Assets/meFull.png";
export default function About() {
    return (
      <>
        <InfoPage pic={meFull}>
          <h1>About</h1>
          <span />
          <p>
            My name is Jonathan Wolf, and I help people solve their problems
            through programming.{' '}
          </p>
          <br />
          <p>
            For the past several years, I have created and managed projects
            aimed at supporting business growth, with a primary focus on
            application development.
          </p>
          <br />
          <p>
            I want to make a difference in the world, and I believe that
            software provides extraordinary opportunities to do so.
          </p>
        </InfoPage>
      </>
    );
}
